import cv from 'opencv.js';
import Vue from 'vue';

export default (_, inject) => {
  inject('cv', cv);
};

// inject('cv', cv);
// Vue.use(cv);
